import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=a93bc6de&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"
import style0 from "./issue.vue?vue&type=style&index=0&id=a93bc6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93bc6de",
  null
  
)

export default component.exports